import type { AdminCatalogEntry } from "./adminNavigationCatalog";

/** Einheitlicher Einstieg für den Shared-Registrierungsablauf. Bestehende URLs bleiben möglich. */
export function adminRegistrationNavigation(path = "/admin/registration"): AdminCatalogEntry {
  return { group: "tenants", path, titleKey: "AdminStructure.registration", icon: "UserAddOutlined" };
}
